import { JobDescriptionContainer } from "klayowebshared";
import { AppContext } from "../../common/AppContext";
import { AbstractDialog, AbstractDialogProps } from "../../components/AbstractDialog";
import { Dialog } from "../../components/dialogs/Dialog";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";

interface JobDescriptionDialogProps extends WithLocaleProps, AbstractDialogProps {
  theme?: any;
  description?: string;
  onClose?: () => void;
}

class JobDescriptionDialogBase extends AbstractDialog<JobDescriptionDialogProps> {
  static contextType = AppContext;

  render() {
    const { theme, onClose, description, translate } = this.props;

    return (
      <Dialog
        title={translate("profile.jobDescription")}
        className='klaro-jobdescdialog'
        theme={theme}
        open={true}
        onClose={onClose}
        maxWidth='md'
        actions={[
          {
            label: translate("common.close"),
            variant: "filled",
            onClick: onClose
          }
        ]}
      >
        <JobDescriptionContainer
          height={null}
          text={description}
          noDescriptionText={translate("common.noJobDescriptionAvailable")}
          showAllText={translate("common.showAll")}
        />
      </Dialog>
    );
  }
}

export const JobDescriptionDialog = withLocale(JobDescriptionDialogBase);
